// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/ava1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/dots-burger.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_right_head{
    /*background-color: #f6f6f9;*/
    background-color: #f9f9f6;
    padding: 24px;
    padding-bottom: 12px;
}

.dashboard_right_head_content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13.5px 0px;
    gap: 20px;
    border-bottom: 1px solid #989FC944;
    padding-top: 0px;
}

.dashboard_right_head_content_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
}

.dashboard_right_head_content_right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
}

.dashboard_right_head_user{
    display: flex;
    align-items: center;
    gap: 24px;
}

.dashboard_right_head_avatar{
    width: 64px;
    height: 64px;
    border-radius: 100%;
    /*background-color: #0009;*/

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}
                
.dashboard_right_head_info{

}

.dashboard_right_head_name{
    font-weight: 400;
    font-size: calc(24px * var(--fontScaler));
    line-height: 33px;

    color: #08080A;
}

.dashboard_right_head_page{
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    user-select: none;
}

.dashboard_right_head_page:hover .dashboard_right_head_page_text{
    color: #6B78A0;
}

.dashboard_right_head_page:hover .dashboard_right_head_page_button{
    color: #6B78A0;
}

.dashboard_right_head_page_text{
    font-weight: 400;
    font-size: calc(16px * var(--fontScaler));
    line-height: 24px;
    color: #8E9ABB;
}

.dashboard_right_head_page_button{
    width: 10px;
    height: 5px;
    flex-shrink: 0;
    color: #8E9ABB;
    transform: rotate(0deg);
    transition: transform 200ms ease-in-out, color 200ms ease-in-out;
}
.dashboard_right_head_page_button--visible{
    transform: rotate(180deg);
}

.dashboard_right_head_tags{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: 9px 7px;
}

.dashboard_right_head_tag{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #D9D9D9;
    padding: 0px 10px;

    font-weight: 400;
    font-size: calc(10px * var(--fontScaler));
    line-height: 18px;
    color: #FFFFFF;
    padding: 0px 10px;
    background: #D9D9D9;
    border-radius: 30px;
}

.dashboard_right_head_tag--active{
    background: rgba(20, 174, 92, 0.7);
}

.dashboard_right_head_burger{
    width: 41px;
    height: 41px;
    border-radius: 100%;
    background-color: #fff;
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 25px;
    background-position: center;
    background-repeat: no-repeat;
}

.dashboard_head_contextMenu_item{
    padding: 8px 20px;
    font-size: calc(14px * var(--fontScaler));
    line-height: 24px;
    color: #212633;
    cursor: pointer;
    white-space: nowrap;
}

.dashboard_head_contextMenu_item:hover{
    background-color: #F3F6FF;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/dashboardHead/DashboardHead.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;;IAE3B,yDAAoD;IACpD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;;AAEA;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,gEAAgE;AACpE;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;;IAEjB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;;IAEd,yDAA2D;IAC3D,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".dashboard_right_head{\n    /*background-color: #f6f6f9;*/\n    background-color: #f9f9f6;\n    padding: 24px;\n    padding-bottom: 12px;\n}\n\n.dashboard_right_head_content{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 13.5px 0px;\n    gap: 20px;\n    border-bottom: 1px solid #989FC944;\n    padding-top: 0px;\n}\n\n.dashboard_right_head_content_left{\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 20px;\n}\n\n.dashboard_right_head_content_right{\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 20px;\n}\n\n.dashboard_right_head_user{\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n.dashboard_right_head_avatar{\n    width: 64px;\n    height: 64px;\n    border-radius: 100%;\n    /*background-color: #0009;*/\n\n    background-image: url('../../../../assets/ava1.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n                \n.dashboard_right_head_info{\n\n}\n\n.dashboard_right_head_name{\n    font-weight: 400;\n    font-size: calc(24px * var(--fontScaler));\n    line-height: 33px;\n\n    color: #08080A;\n}\n\n.dashboard_right_head_page{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.dashboard_right_head_page:hover .dashboard_right_head_page_text{\n    color: #6B78A0;\n}\n\n.dashboard_right_head_page:hover .dashboard_right_head_page_button{\n    color: #6B78A0;\n}\n\n.dashboard_right_head_page_text{\n    font-weight: 400;\n    font-size: calc(16px * var(--fontScaler));\n    line-height: 24px;\n    color: #8E9ABB;\n}\n\n.dashboard_right_head_page_button{\n    width: 10px;\n    height: 5px;\n    flex-shrink: 0;\n    color: #8E9ABB;\n    transform: rotate(0deg);\n    transition: transform 200ms ease-in-out, color 200ms ease-in-out;\n}\n.dashboard_right_head_page_button--visible{\n    transform: rotate(180deg);\n}\n\n.dashboard_right_head_tags{\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 9px 7px;\n}\n\n.dashboard_right_head_tag{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #D9D9D9;\n    padding: 0px 10px;\n\n    font-weight: 400;\n    font-size: calc(10px * var(--fontScaler));\n    line-height: 18px;\n    color: #FFFFFF;\n    padding: 0px 10px;\n    background: #D9D9D9;\n    border-radius: 30px;\n}\n\n.dashboard_right_head_tag--active{\n    background: rgba(20, 174, 92, 0.7);\n}\n\n.dashboard_right_head_burger{\n    width: 41px;\n    height: 41px;\n    border-radius: 100%;\n    background-color: #fff;\n    flex-shrink: 0;\n\n    background-image: url('../../../../assets/dots-burger.svg');\n    background-size: 25px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.dashboard_head_contextMenu_item{\n    padding: 8px 20px;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 24px;\n    color: #212633;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.dashboard_head_contextMenu_item:hover{\n    background-color: #F3F6FF;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
